import { render, staticRenderFns } from "./PhotoReportColorEditModal.vue?vue&type=template&id=d065898c&scoped=true&"
import script from "./PhotoReportColorEditModal.vue?vue&type=script&lang=js&"
export * from "./PhotoReportColorEditModal.vue?vue&type=script&lang=js&"
import style0 from "./PhotoReportColorEditModal.vue?vue&type=style&index=0&id=d065898c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d065898c",
  null
  
)

export default component.exports